import { emptyGuid } from '../../../webmodule-common/other/api/guid';
import type { QuoteSupplier } from '../../quotes/quote-service';

// Pure predicate: a supplier is usable when it has a real supplier id (present and
// not the empty guid) AND it is currently online.
export function isSupplierUsable(supplier: QuoteSupplier): boolean {
  return !!supplier.supplierId && supplier.supplierId !== emptyGuid && supplier.online;
}
